/**
 * Semantic linter rule for LightOccluder2D, ported from the first arm of
 * `LightOccluder2D::get_configuration_warnings()` (light_occluder_2d.cpp:265-278):
 * a null `occluder` (light_occluder_2d.cpp:298), which an absent key is. The empty
 * polygon arm needs the resource's `polygon` value, which this linter does not resolve.
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
import { resourceSlotIsEmpty } from '../../../linter/resourceChecker.js';
const arms = {
    missingOccluder: groundedArm('lightoccluder2d-requires-occluder', { kind: 'configuration-warning' }),
};
function checkLightOccluder2D(context) {
    const { node } = context;
    if (!resourceSlotIsEmpty(node.rawProperties.occluder))
        return [];
    return [
        armDiagnostic(arms.missingOccluder, node, `LightOccluder2D '${node.name}' has no occluder polygon set. An occluder polygon must be set (or drawn) for this occluder to take effect.`),
    ];
}
const lightOccluder2DRequiresOccluderRule = {
    meta: {
        name: 'valid-lightoccluder2d-occluder',
        description: 'Warns when a LightOccluder2D has no occluder polygon resource set',
        category: 'validation',
        applicableNodeTypes: ['LightOccluder2D'],
        emits: armEmits(arms),
    },
    check: checkLightOccluder2D,
};
ruleRegistry.register(lightOccluder2DRequiresOccluderRule);
//# sourceMappingURL=linter.js.map